<script>
import Dropdown from "../Dropdown.vue";
import {mapStores, mapWritableState} from "pinia";
import {SessionCategoriesStore} from "../../stores/SessionCategoriesStore";
import {TherapiesStore} from "../../stores/TherapiesStore";
import {FormDataStore} from "../../stores/FormDataStore";

export default {
  name: "SetSessionCategoryQuestion",
  components: {Dropdown},
  computed: {
    ...mapStores(SessionCategoriesStore, TherapiesStore),
    ...mapWritableState(FormDataStore, ['formData', 'error']),
  },
  data: function () {
    return {
      sessionCategories: [],
    };
  },
  methods: {
    async getSessionCategories() {
      try {
        this.sessionCategories = await this.categoriesStore.getSessionCategories();
      } catch (e) {
        this.error = true;
      }
    },
    setSessionCategory(category) {
      this.formData.sessionCategory.sessionCategory = category;
      this.therapiesStore.setTherapies(this.formData.sessionCategory.sessionCategory.therapyTypes);
      this.selecting = false;
    }
  },
  mounted() {
    this.getSessionCategories();
  }
}
</script>

<template>
<div id="setSessionCategoryQuestion">
  <h2>Please confirm <strong>what you require</strong></h2>
  <div class="mb-4" v-if="this.sessionCategories.length > 0">
    <Dropdown :value="this.formData.sessionCategory.sessionCategory" :options="sessionCategories" @change="setSessionCategory" />
  </div>
</div>
</template>

<style scoped>

</style>